export default class Blog {
  constructor() {
    // Blog
    // window.onload = this.resizeAllGridItems();
    // window.addEventListener('resize', this.resizeAllGridItems);

    const select = document.querySelector('.filters .filter-tags');
    if (select) {
      select.addEventListener('change', () => {
        window.location.href = select.value;
        // if (document.body.classList.contains('tag')) {
        // } else {
        //   this.manageArticles(select.value);
        // }
      });
    }
  }

  resizeGridItem(item){
    const grid = document.querySelector('section.content .news-wrapper');
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    const rowSpan = Math.ceil((item.querySelector('.item-container').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
    item.style.gridRowEnd = 'span '+rowSpan;
  }

  resizeAllGridItems(){
    this.allItems = document.querySelectorAll('.item');
    for(let x = 0; x < this.allItems.length; x++){
      this.resizeGridItem( this.allItems[x] );
    }
  }

  resizeInstance(instance){
    const item = instance.elements[0];
    this.resizeGridItem(item);
  }

  manageArticles(filter) {
    console.log('test');
    const items = document.querySelectorAll('section.content .news-wrapper .item');
    if (filter === 'all') {
      document.querySelector('section.content .news-wrapper').classList.remove('filtered');
      items.forEach((item) => {
        item.classList.remove('visible');
      });
    } else {
      document.querySelector('section.content .news-wrapper').classList.add('filtered');
      if (items.length > 0) {
        items.forEach((item) => {
          if (item.dataset.tags) {
            if (item.dataset.tags.includes(filter)) {
              item.classList.add('visible');
            } else {
              item.classList.remove('visible');
            }
          }
        });
      }
    }
  }
}